import React, { FC } from 'react';

import { useApi, useFetchData } from '@app/hooks';
import { QueryTable, TableColumn } from '@app/components/common/table';

import columns from './columns';
import { Log } from '../../../api/models/admin';

const LogsTable: FC = () => {
  const api = useApi();
  const [fetchData] = useFetchData({
    method: api.service.getLog
  });

  return (
    <>
      <QueryTable
        title="Logs"
        columns={columns as TableColumn<Log>[]}
        fetchData={fetchData}
      />
    </>
  );
};

export default LogsTable;
